import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        this.format()
    }

    format() {
        const input = this.element
        let value = input.value.replace(/\D/g, '')
        const maxLen = 10

        if (value.length > maxLen) {
            value = value.substring(0, maxLen)
        }

        if (value.length > 6) {
            input.value = `(${value.substring(0, 3)}) ${value.substring(3, 6)}-${value.substring(6)}`
        } else if (value.length > 3) {
            input.value = `(${value.substring(0, 3)}) ${value.substring(3)}`
        } else if (value.length > 0) {
            input.value = `(${value}`
        } else {
            input.value = ''
        }
    }
}
